import { useEffect, useRef, useState } from "react";
import { StatusPedido, opcoesStatusPedido } from "../../dto/StatusPedido";
import { PedidosServices } from "../../services/PedidosService";
import { mostraMensagemErro } from "../../helpers/Notificacoes";
import { UserInfo } from "../../dto/UserInfo";

export const useStatusPedido = () => {

    const pedidosService = new PedidosServices();
    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);
    const REACT_APP_ADM_MOBILE = process.env.REACT_APP_ADM_MOBILE;
    const [statusPedidos, setStatusPedidos] = useState<StatusPedido[]>();
    const [statusCarregados, setStatusCarregados] = useState(false);

    const jaBuscouRef = useRef(false);

    async function buscaStatusPedidos() {
        try {
            const status = await pedidosService.get('/v1/status-pedido');
            setStatusPedidos(status.status);
            setStatusCarregados(true);
            return status.status;

        } catch (erro) {
            setStatusCarregados(false);
            mostraMensagemErro('Erro ao buscar status.');
            return;
        }
    }

    useEffect(() => {
        if (userInfo.email === REACT_APP_ADM_MOBILE) {
            return;
        }
        if (!statusCarregados && !jaBuscouRef.current) {
            jaBuscouRef.current = true; // marca que já tentou buscar
            buscaStatusPedidos();
        }
    }, [userInfo.email, statusCarregados]);
    

    function selecionarStatusDoPedido(id: number) {
        const opcoesStatusSelecionado = opcoesStatusPedido.find(opcao => opcao.id === id);
        const statusSelecionado = statusPedidos?.find(status => status.nroStatusPedido === opcoesStatusSelecionado?.nroStatusPedido);
        return statusSelecionado;
    }


    function retornaOpcoesStatus(idStatusPedido: string) {
        const status = statusPedidos?.find(status => status.idStatusPedido === idStatusPedido);
        const opcoesStatusSelecionado = opcoesStatusPedido.find(opcao => opcao.nroStatusPedido === status?.nroStatusPedido);
        return opcoesStatusSelecionado;
    }


    return {
        statusPedidos,
        buscaStatusPedidos,
        statusCarregados,
        selecionarStatusDoPedido,
        retornaOpcoesStatus
    }
}